import numeral from "numeral";
import React, { useState } from "react";
import { Button, Card, Form, Modal, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import usePalette from "../../../../../hooks/usePalette";
import Select, { components } from "react-select";
import { customStylesForm } from "../../../../../components/common/customStyleSelect";
import CurrencyInput from "react-currency-input-field";
import { isEmpty, isNull } from "lodash";

import Icon from "@mdi/react";
import { mdiLoading } from "@mdi/js";

// import { addNewProjectScope } from "../../../../../redux/slices/certify/projectsSlice";

import {
  createCertifyFinancial,
  createRejectedScopeList,
} from "../../../../../redux/slices/utilsSlice";

const AddNewProjectScope = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const { project, projectScopeItems, ceilingFlowState } = useSelector(
    (state) => ({
      project: state.certifyReducer.project.data,
      projectScopeItems: state.utilsReducer.dropdownItems.projectScopeItems,
      ceilingFlowState: state.utilsReducer.certifyFinancial,
    }),
  );

  const [costDescriptionValue, setCostDescriptionValue] = useState(null);
  const [costRequiredValue, setCostRequiredValue] = useState("");
  const [ceilingValue, setCeilingValue] = useState("");

  const handleOnChange = (value) => {
    setCostDescriptionValue(value);
  };

  const handleAddProjectScope = async () => {
    const params = {
      project_id: project.id,

      cost_description: costDescriptionValue?.value || "",
      cost_required: costRequiredValue,
      ceiling: ceilingValue,
    };

    // await dispatch(addNewProjectScope(params));

    const handleRemoveRejectedScope = (status) => {
      if (isEmpty(status)) {
        const updatedArray = project.financial_details.map((financial) => {
          let updatedChildren = [];
          if (!isEmpty(financial.ceiling_flow_details)) {
            updatedChildren = financial?.ceiling_flow_details.map(
              (flow, idx) => ({
                ...flow,
                id: flow?.id || idx + 1,
                financial_detail_id: financial.id,
                cost_description: financial.cost_description,
              }),
            );
          } else {
            updatedChildren = [
              {
                year: 2030,
              },
            ];
          }

          return {
            ...financial,
            ceiling_flow_details: updatedChildren,
          };
        });
        console.log(updatedArray);
        const childrenArray = updatedArray
          .map((financial) => financial.ceiling_flow_details)
          .reduce((acc, flow) => acc.concat(flow), []);

        const childrenArrayTest = updatedArray
          .map((financial) => financial.ceiling_flow_details)
          .reduce((acc, flow) => []);

        // Reset Reject Scope List
        dispatch(createRejectedScopeList([]));
        return childrenArray;
      } else {
        const findRejectedList = project.financial_details.flatMap((obj1) =>
          obj1.ceiling_flow_details.filter((obj2) =>
            obj2.ceiling_flow_detail_stages.some(
              (item) => item.status === status.toString(),
            ),
          ),
        );

        const rejectedList = project.financial_details.filter((obj1) =>
          findRejectedList.some((item) => item.financial_detail_id === obj1.id),
        );

        // Store in redux
        dispatch(createRejectedScopeList(rejectedList));

        const newFinancialList = project.financial_details.filter(
          (obj1) =>
            !findRejectedList.some(
              (item) => item.financial_detail_id === obj1.id,
            ),
        );

        const updatedArray = newFinancialList.map((financial) => {
          const ceilingFlowList = financial.ceiling_flow_details.map((flow) => {
            const removeRejected = flow.ceiling_flow_detail_stages.filter(
              (item) => item.status !== status.toString(),
            );

            return {
              ...flow,
              financial_detail_id: financial.id,
              cost_description: financial.cost_description,
            };
          });
          return { ...financial, ceiling_flow_details: ceilingFlowList };
        });

        const childrenArray = updatedArray
          .map((financial) => financial.ceiling_flow_details)
          .reduce((acc, flow) => acc.concat(flow), []);

        return childrenArray;
      }
    };

    let newArray = [];

    switch (project.stages) {
      case "4":
        newArray = handleRemoveRejectedScope("");
        break;
      case "5":
        newArray = handleRemoveRejectedScope("7");
        break;
      case "6":
        newArray = handleRemoveRejectedScope("7");
        break;
    }

    console.log(ceilingFlowState);

    const temporaryData = window.localStorage.getItem("TEMP_CERTIFY_DATA");

    if (isNull(temporaryData)) {
      dispatch(createCertifyFinancial(newArray));
    } else {
      const data = JSON.parse(temporaryData);
      dispatch(createCertifyFinancial(data));
    }

    // onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size='md'
      centered
      keyboard={false}
      backdrop='static'
    >
      <Modal.Body>
        <div className='p-4'>
          <h4 className='mb-3'>Tambah Skop Projek</h4>
          <Form.Group className='mb-3'>
            <Form.Label>Projek Skop</Form.Label>
            <Select
              name='cost_description'
              placeholder='Pilih Skop...'
              className='react-select-container'
              classNamePrefix='react-select'
              isSearchable
              options={projectScopeItems}
              styles={{
                ...customStylesForm,
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                // Custom styles for multiline display
                singleValue: (provided) => ({
                  ...provided,
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  maxWidth: "100%",
                  overflow: "visible", // Allow text to expand
                }),
                control: (provided) => ({
                  ...provided,
                  minHeight: "auto", // Remove fixed height
                  alignItems: "flex-start", // Align text to top
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  padding: "8px", // Match textarea padding
                  flexWrap: "wrap", // Allow text to wrap
                }),
                input: (provided) => ({
                  ...provided,
                  padding: 0,
                  margin: 0,
                }),
              }}
              menuPortalTarget={document.body}
              menuPosition='absolute'
              value={costDescriptionValue}
              onChange={(value) => handleOnChange(value)}
              noOptionsMessage={() => "Tiada pilihan"}
              components={{
                SingleValue: ({ children, ...props }) => (
                  <components.SingleValue {...props}>
                    <div
                      style={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        maxWidth: "100%",
                      }}
                    >
                      {children}
                    </div>
                  </components.SingleValue>
                ),
              }}
            />
          </Form.Group>
          <Form.Group className='mb-3'>
            <Form.Label>Jumlah Kos Dipohon</Form.Label>
            <Form.Control
              as={CurrencyInput}
              name='cost_required'
              placeholder='0.00'
              decimalsLimit={2}
              value={costRequiredValue}
              onValueChange={(value) => setCostRequiredValue(value)}
            />
          </Form.Group>
          <Form.Group className='mb-3'>
            <Form.Label>Jumlah Siling Dipohon</Form.Label>
            <Form.Control
              as={CurrencyInput}
              name='ceiling_value'
              placeholder='0.00'
              decimalsLimit={2}
              value={ceilingValue}
              onValueChange={(value) => setCeilingValue(value)}
            />
          </Form.Group>
        </div>
        <div className='d-flex justify-content-end gap-3 px-4'>
          <Button variant='light' onClick={onHide}>
            Batal
          </Button>
          <Button
            className='px-3'
            variant='success'
            onClick={handleAddProjectScope}
          >
            {/* {btnLoading ? (
              <Icon className='mx-3' path={mdiLoading} size={0.8} spin={true} />
            ) : ( */}
            <span style={{ marginLeft: 2.5, marginRight: 2.5 }}>Simpan</span>
            {/* )} */}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddNewProjectScope;
